import React from 'react';
import { Box, Card, HStack, Icon, Label, Text } from '@medely/ui-kit';
import { CircularAvatar } from '../icons/CircularAvatar';

export const PerfectAttendance = () => {
  return (
    <Card>
      <HStack alignItems="center" gap={2} px={1}>
        <CircularAvatar color="state.teal.backing" width="35px" height="35px">
          <Icon
            name="award"
            bgColor="state.teal.backing"
            variant="custom"
            color="state.teal.primary"
          />
        </CircularAvatar>
        <Label size="l">Keep up the good work!</Label>
      </HStack>
      <Box py={2} px={1}>
        <Text size="l">
          Your stellar attendance is much appreciated and enables full access to all of Medely’s
          shifts and assignments.
        </Text>
      </Box>
    </Card>
  );
};
